import type { TFunction } from "i18next";
import type { EligibilityReason } from "@/services/edgeFunctionWrappers/bookingsRpcWrapper";

/** Libellé du badge d'inéligibilité selon la raison renvoyée par le serveur. */
export function getIneligibleLabel(t: TFunction, reason?: EligibilityReason): string {
  const fallback = t("bookingAttendeesTab.subscriptionExpired", { ns: "bookingui" });
  if (!reason?.code) return fallback;
  let date = "";
  if (reason.startDate) {
    const [, m, d] = reason.startDate.split("-");
    date = `${d}/${m}`;
  }
  return t(`bookingAttendeesTab.ineligibleReasons.${reason.code}`, { ns: "bookingui", date, defaultValue: fallback });
}
